import axiosInstance from '../api';
import {
  CurrentTermsResponse,
  AgreeToTermsRequest,
  AgreeToTermsResponse,
  AgreementHistoryResponse,
  UserAgreementStatusResponse,
} from './termsApi.types';

/**
 * 現在有効な利用規約を取得
 */
export const getCurrentTerms = async (): Promise<CurrentTermsResponse> => {
  try {
    const response = await axiosInstance.get<CurrentTermsResponse>('/terms/current');
    return response.data;
  } catch (error) {
    console.error('Get current terms error:', error);
    throw error;
  }
};

/**
 * 利用規約に同意
 */
export const agreeToTerms = async (request: AgreeToTermsRequest): Promise<AgreeToTermsResponse> => {
  try {
    const response = await axiosInstance.post<AgreeToTermsResponse>('/terms/agree', request);
    return response.data;
  } catch (error) {
    console.error('Agree to terms error:', error);
    throw error;
  }
};

/**
 * ユーザーの利用規約同意状況を取得
 */
export const getUserAgreementStatus = async (): Promise<UserAgreementStatusResponse> => {
  try {
    const response = await axiosInstance.get<UserAgreementStatusResponse>('/terms/user-agreement-status');
    return response.data;
  } catch (error) {
    console.error('Get user agreement status error:', error);
    throw error;
  }
};

/**
 * ユーザーの利用規約同意履歴を取得
 */
export const getAgreementHistory = async (): Promise<AgreementHistoryResponse> => {
  try {
    const response = await axiosInstance.get<AgreementHistoryResponse>('/terms/agreement-history');
    return response.data;
  } catch (error) {
    console.error('Get agreement history error:', error);
    throw error;
  }
};